import type { TFunction } from 'i18next';
import type { HostelStatus, RentStatus } from '@/api/types';

type TFn = TFunction;

export function hostelStatusLabel(t: TFn, status: HostelStatus | string): string {
  switch (status) {
    case 'PENDING_APPROVAL': return t('hostel.statusPendingApproval', 'Pending Approval');
    case 'ACTIVE': return t('hostel.statusActive', 'Active');
    case 'SUSPENDED': return t('hostel.statusSuspended', 'Suspended');
    case 'REJECTED': return t('hostel.statusRejected', 'Rejected');
    default: return status;
  }
}

export function rentStatusLabel(t: TFn, status: RentStatus | string): string {
  switch (status) {
    case 'PENDING': return t('rent.pending', 'Pending');
    case 'PAID': return t('rent.paid', 'Paid');
    case 'PARTIAL': return t('rent.partial', 'Partial');
    case 'OVERDUE': return t('rent.overdue', 'Overdue');
    case 'WAIVED': return t('rent.waived', 'Waived');
    default: return status;
  }
}

export function paymentMethodLabel(t: TFn, method: string): string {
  switch (method) {
    case 'CASH': return t('rent.methodCash', 'Cash');
    case 'UPI': return t('rent.methodUpi', 'UPI');
    case 'BANK_TRANSFER': return t('rent.methodBankTransfer', 'Bank Transfer');
    case 'CREDIT_CARD': return t('rent.methodCreditCard', 'Credit Card');
    case 'DEBIT_CARD': return t('rent.methodDebitCard', 'Debit Card');
    case 'CHEQUE': return t('rent.methodCheque', 'Cheque');
    case 'OTHER': return t('rent.methodOther', 'Other');
    default: return method;
  }
}
